import _ from 'underscore';

import { ProjectMapper } from '~src/projects/models/mappers/ProjectMapper';

import { ILocationInfo } from '../../../personalSpace/model/ILocationInfo';
import { ISimulationUsageInfo } from '../../../spacesPlatform/models/IUsageInfo';
import { ContentMapper } from '../../../spacesPlatform/models/mappers/ContentMapper';
import { MapperHelper } from '../../../spacesPlatform/models/mappers/MapperHelper';
import { INamedItemInfo } from '../../../spacesPlatform/models/resourceInfoParts';
import { IUserInfo } from '../../../userManagement/users/models/IUserInfo';
import { UserMapper } from '../../../userManagement/users/models/mappers/UserMapper';
import { ISimulation, ISimulationDetail } from '../../serverApi/types/ISimulation';
import { ISimulationDetailInfo, ISimulationInfo } from '../ISimulationInfo';

export module SimulationMapper {
  const M = MapperHelper;

  export function map(
    serverApiMetrics: ISimulation[],
    users: _.Dictionary<IUserInfo>,
    projects: _.Dictionary<INamedItemInfo>,
    favoriteSimulations: _.Dictionary<any> = {},
    locations: ILocationInfo[] = []
  ): ISimulationInfo[] {
    const simulationsToLocation = ContentMapper.getContentToLocationMap(ContentMapper.ContentTypeToTargetMap.simulation, locations);
    return serverApiMetrics.map((m: ISimulation) => {
      return mapOne(m, users[m.ownerId], projects[m.projectId], !!favoriteSimulations[m.id], simulationsToLocation[m.id]);
    });
  }

  export function mapOne(
    simulation: ISimulation,
    owner?: IUserInfo,
    project?: INamedItemInfo,
    favorite?: boolean,
    location?: ILocationInfo
  ): ISimulationInfo {
    return {
      createdAt: M.toDate(simulation.createdAt),
      updatedAt: M.toDate(simulation.updatedAt),
      description: simulation.description,
      id: simulation.id,
      luid: simulation.luid,
      name: simulation.name,
      owner: UserMapper.mapOne(owner),
      favorite: favorite,
      contentType: 'simulation',
      tags: M.sortTags(simulation.tags),
      project: project,
      usageInfo: <ISimulationUsageInfo>{favoritesTotal: 0},
      usageInfoMaxValues: <ISimulationUsageInfo>{},
      location: location,
    };
  }

  export function mapDetail(p: ISimulationDetail): ISimulationDetailInfo {
    return {
      createdAt: M.toDate(p.createdAt),
      updatedAt: M.toDate(p.updatedAt),
      description: p.description,
      id: p.id,
      luid: p.luid,
      name: p.name,
      owner: UserMapper.mapOne(p.owner),
      favorite: p.favorite,
      contentType: 'simulation',
      tags: M.sortTags(p.tags),
      project: p.project ? ProjectMapper.mapName(p.project) : null,
    };
  }

  export function mapFromCRASS(p: any): ISimulationInfo {
    return {
      createdAt: M.toDate(p.createdTime) || M.toDateFromTimeOffsetObject(p.createdTime),
      updatedAt: M.toDate(p.modifiedTime) || M.toDateFromTimeOffsetObject(p.modifiedTime),
      description: p.description,
      id: p.id + '',
      luid: p.luid,
      name: p.title,
      favorite: p.favorite,
      contentType: 'simulation',
      tags: M.sortTags(p.tags),
      project: {
        id: p.projectId ?? p.parentProjectId,
        name: p.containerName
      },
      owner: UserMapper.mapOneOwnerFromCRASS(p),
      usageInfo: <ISimulationUsageInfo>{favoritesTotal: 0},
      usageInfoMaxValues: <ISimulationUsageInfo>{}
    };
  }
}
